import { render, staticRenderFns } from "./block.vue?vue&type=template&id=1fb87421&scoped=true&lang=pug&"
import script from "./block.vue?vue&type=script&lang=js&"
export * from "./block.vue?vue&type=script&lang=js&"
import style0 from "./dialogs.scss?vue&type=style&index=0&id=1fb87421&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb87421",
  null
  
)

export default component.exports